import { CartEventActionEnum, OrderStatusEnum, PaymentTypeEnum } from '../../../core/enums/order/order';

export const getCartEventAction = (action) => {
    switch (action) {
        case CartEventActionEnum.CREATE.value:
            return CartEventActionEnum.CREATE.label;
        case CartEventActionEnum.ADD_PURCHASE_PRODUCT.value:
            return CartEventActionEnum.ADD_PURCHASE_PRODUCT.label;
        case CartEventActionEnum.ADD_PRODUCT_FAIL.value:
            return CartEventActionEnum.ADD_PRODUCT_FAIL.label;
        case CartEventActionEnum.ADD_RESERVATION_PRODUCT.value:
            return CartEventActionEnum.ADD_RESERVATION_PRODUCT.label;
        case CartEventActionEnum.REMOVE_PRODUCT.value:
            return CartEventActionEnum.REMOVE_PRODUCT.label;
        case CartEventActionEnum.CHANGE_STATUS.value:
            return CartEventActionEnum.CHANGE_STATUS.label;
        case CartEventActionEnum.REFRESH.value:
            return CartEventActionEnum.REFRESH.label;
        case CartEventActionEnum.RECREATE.value:
            return CartEventActionEnum.RECREATE.label;
        case CartEventActionEnum.FINALIZE.value:
            return CartEventActionEnum.FINALIZE.label;
        default:
            return CartEventActionEnum.CLEAR.label;
    }
};

export const getOrderStatus = (status) => {
    switch (status) {
        case OrderStatusEnum.CANCELED.value:
            return OrderStatusEnum.CANCELED.label;
        case OrderStatusEnum.CREATED.value:
            return OrderStatusEnum.CREATED.label;
        case OrderStatusEnum.IN_REALIZATION.value:
            return OrderStatusEnum.IN_REALIZATION.label;
        case OrderStatusEnum.WAITING_FOR_PAYMENT.value:
            return OrderStatusEnum.WAITING_FOR_PAYMENT.label;
        case OrderStatusEnum.FINISHED.value:
            return OrderStatusEnum.FINISHED.label;
        case OrderStatusEnum.FAIL_PAYMENT.value:
            return OrderStatusEnum.FAIL_PAYMENT.label;
        case OrderStatusEnum.FAIL_UPDATE_POD_RESOURCE.value:
            return OrderStatusEnum.FAIL_UPDATE_POD_RESOURCE.label;
        case OrderStatusEnum.PARTIALLY_RETURNED.value:
            return OrderStatusEnum.PARTIALLY_RETURNED.label;
        case OrderStatusEnum.RETURNED.value:
            return OrderStatusEnum.RETURNED.label;
        default:
            return OrderStatusEnum.UNKNOWN.label;
    }
};

export const getOrderStatusColor = (status) => {
    switch (status) {
        case OrderStatusEnum.CANCELED.value:
        case OrderStatusEnum.PARTIALLY_RETURNED.value:
        case OrderStatusEnum.RETURNED.value:
            return 'warning';
        case OrderStatusEnum.CREATED.value:
            return 'info';
        case OrderStatusEnum.IN_REALIZATION.value:
        case OrderStatusEnum.WAITING_FOR_PAYMENT.value:
            return 'secondary';
        case OrderStatusEnum.FINISHED.value:
            return 'success';
        case OrderStatusEnum.FAIL_PAYMENT.value:
        case OrderStatusEnum.FAIL_UPDATE_POD_RESOURCE.value:
            return 'error';
        default:
            return 'none';
    }
};

export const getPaymentType = (paymentType) => {
    switch (paymentType) {
        case PaymentTypeEnum.ADDED_CARD.value:
            return PaymentTypeEnum.ADDED_CARD.label;
        case PaymentTypeEnum.ONLINE.value:
            return PaymentTypeEnum.ONLINE.label;
        case PaymentTypeEnum.TERMINAL.value:
            return PaymentTypeEnum.TERMINAL.label;
        case PaymentTypeEnum.DEDUCT_FROM_SALARY.value:
            return PaymentTypeEnum.DEDUCT_FROM_SALARY.label;
        case PaymentTypeEnum.NO_REQUIRED.value:
            return PaymentTypeEnum.NO_REQUIRED.label;
        default:
            return PaymentTypeEnum.UNKNOWN.label;
    }
};

export const getOrderStatusOptions = [
    { value: OrderStatusEnum.CANCELED.value, label: OrderStatusEnum.CANCELED.label },
    { value: OrderStatusEnum.CREATED.value, label: OrderStatusEnum.CREATED.label },
    { value: OrderStatusEnum.IN_REALIZATION.value, label: OrderStatusEnum.IN_REALIZATION.label },
    { value: OrderStatusEnum.WAITING_FOR_PAYMENT.value, label: OrderStatusEnum.WAITING_FOR_PAYMENT.label },
    { value: OrderStatusEnum.FINISHED.value, label: OrderStatusEnum.FINISHED.label },
    { value: OrderStatusEnum.FAIL_PAYMENT.value, label: OrderStatusEnum.FAIL_PAYMENT.label },
    { value: OrderStatusEnum.FAIL_UPDATE_POD_RESOURCE.value, label: OrderStatusEnum.FAIL_UPDATE_POD_RESOURCE.label },
    { value: OrderStatusEnum.PARTIALLY_RETURNED.value, label: OrderStatusEnum.PARTIALLY_RETURNED.label },
    { value: OrderStatusEnum.RETURNED.value, label: OrderStatusEnum.RETURNED.label },
];
